import styled from 'styled-components';
import { TextField } from '@dsny/dsny-component-library';
import { Link } from 'react-router-dom';
import { device } from 'src/styles/global';
import themeValues from 'src/styles/theme';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 16px;
  width: 100%;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 840px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  overflow: hidden;
`;

export const CardInner = styled.div`
  padding: 32px 32px 0;

  @media ${device.mobile} {
    padding: 24px 24px 0;
  }
`;

export const Title = styled.h1`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.neutralW20};
  margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
  margin: 0 0 24px 0;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralW40};
`;

export const TextFieldWrapper = styled(TextField)`
  font-size: 14px;
  margin-bottom: 32px;

  @media ${device.mobile} {
    width: 100%;
  }
`;

export const SearchWrapperStyles = {
  paddingRight: '0px',
  marginBottom: '0px',
};

export const SearchInputStyles = {
  height: '44px',
  borderRadius: '5px',
  color: themeValues.colors.neutralW40,
};

export const SearchTailingStyles = {
  display: 'flex',
  alignItems: 'center',
  paddingRight: '10px',
  marginTop: '-12px',
  width: '24px',
};

export const Table = styled.div`
  display: block;
  width: calc(100% + 64px);
  margin: 0 -32px;
  max-height: calc((64px + 1px) * 5.5 + 1px);
  overflow-y: auto;
  border-top: 1px solid ${({ theme }) => theme.colors.neutralW90};
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.neutralW70} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.neutralW70};
    border-radius: 999px;
  }
`;

export const RowText = styled.div`
  flex: 1 1 0;
  min-width: 0;
  padding-right: 32px;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutralW10};
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 64px;
  padding: 0 40px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralW90};

  &:hover {
    background: ${({ theme }) => theme.colors.neutralW100};
  }

  &:hover ${RowText} {
    text-decoration: underline;
  }
`;

export const RowIcon = styled.div`
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
`;

export const NoResultsRow = styled(Row)`
  cursor: default;

  &:hover {
    background: transparent;
  }

  &:hover ${RowText} {
    text-decoration: none;
  }
`;

export const ErrorStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 443px;
  text-align: center;
  padding: 32px 24px;

  @media ${device.mobile} {
    min-height: 320px;
    padding: 24px 16px;
  }
`;

export const ErrorTitle = styled.h1`
  margin: 0 0 16px 0;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.neutralW20};

  @media ${device.mobile} {
    font-size: 20px;
  }
`;

export const RetryLink = styled(Link)`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutralW40};
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.neutralW20};
    outline-offset: 2px;
  }
`;
